import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const APIKeyProjectModel = types.model("APIKeyProjectModel", {
  projectId: types.identifier,
  projectName: types.string,
});

export const createAPIKeyProjectModel = (
  snapshot: SnapshotIn<typeof APIKeyProjectModel>,
): Instance<typeof APIKeyProjectModel> => APIKeyProjectModel.create(snapshot);
